export default {
  path: '/cloudPlatformZone',
  name: 'CloudPlatformZone',
  children: [
    {
      path: '',
      name: 'CloudPlatformZoneIndex',
      component: () => import('@/projects/CloudPlatformZone/pages/index'),
    }
  ]
}
